import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {

  requestPingStart,
  requestPingSuccess,
  requestPingFail,

  authenStart,
  authenSuccess,
  authenFail,

  requestLogoutStart,
  requestLogoutSuccess,
  requestLogoutFail,

  // requestRolePermissionStart,
  // requestRolePermissionSuccess,
  // requestRolePermissionFail,

  // setRolePermissionStart,
  // setRolePermissionSuccess,
  // setRolePermissionFail,

} from '../actions/authen';

import { PERMISSIONS_INFO_KEY } from '@root/jnzAuthWrapper/permission-keys';


import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;


export function* requestLogin({ payload }) {

  /*console.log('[sages] requestLogin : ', payload);*/

  const { redirect } = payload;
  const apiURL = `${url}/auth/line?redirect_to=${redirect}`;

  //====================================================================================================================

  try {

    const { data, error, code, success, msg } = yield method_GET({ url: apiURL });

    /*console.log("[sages] requestLogin  : ", { data, error, code, success, msg });*/

    if (code === 0) {

      /*console.log('response : [data]', { data })*/

      try {
        localStorage.setItem('user_profile', JSON.stringify(data));
      } catch (error) { }

      yield put(authenSuccess(data));
    }
    else
      yield put(authenFail(error?.data || {}));


  } catch (error) {

    console.error("[sages] requestLogin Fail : ", error);
    yield put(authenFail(error));
  }

  //====================================================================================================================

}

export function* requestLogout({ payload }) {

  const apiURL = `${url}/api/v1/auth/logout`;

  try {

    /*console.log('[sages] requestLogout : ', { payload });*/

    const user_profile = JSON.parse(localStorage.getItem('user_profile'));
    /*console.log('user_profile : ', { user_profile })*/

    const { token } = payload;
    const data = yield method_GET({ url: apiURL, params: '', token: token || user_profile?.token, param: { timestamp: moment().unix() } });


    /*console.log('[sages] requestLogoutSuccess : ', { data });*/

    yield put(requestLogoutSuccess(data));


  } catch (error) {

    console.error('[sages] requestLogoutFail : ', { error });
    yield put(requestLogoutFail(error));
  }
}

export function* requestUserProfile(payload = {}) {

  const apiURL = `${url}/v1/user/profile`;

  try {
    const token = localStorage.getItem('token');

    const { data } = yield method_GET({ url: apiURL, param: '', token: token })
    // yield put(requestLogoutSuccess(data));

  } catch (error) {
    yield put(requestLogoutFail(error));
  }

}

export function* requestPing({ payload }) {

  /*console.log('[sages] requestPing : ', payload);*/

  const { redirect } = payload;
  const apiURL = `${url}/backend/v1/auth/ping`;//'/api/v1/auth/ping'

  //====================================================================================================================

  try {

    const { data, error, code, success, msg } = yield method_GET({ url: apiURL });

    /*console.log("[sages] requestPing : ", { data, error, code, success, msg });*/

    if (code === 0) {

      /*console.log('[sages] requestPing : response : [data]', { data })*/

      try {
        // localStorage.setItem('user_profile', JSON.stringify(data));
      } catch (error) { }

      yield put(requestPingSuccess(data));
    }
    else
      yield put(requestPingFail(error?.data || {}));


  } catch (error) {

    console.error("[sages] requestPing Fail : ", error);
    yield put(requestPingFail(error));
  }

  //====================================================================================================================

}

// export function* requestRolePermission({ payload }) {

//   console.log('[sages] requestRolePermission : ', payload);

//   //====================================================================================================================

//   try {

//     let _rolePermission;

//     console.log("[sages] requestRolePermission : ", { _rolePermission });

//     async function getRolePermission() {

//       _rolePermission = await sessionStorage.getItem(PERMISSIONS_INFO_KEY) || {};
//     }

//     getRolePermission();

//     console.log("[sages] requestRolePermission : ", { _rolePermission });

//     // requestRolePermissionSuccess(data)


//   } catch (error) {

//     console.log("[sages] requestRolePermission Fail : ", error);
//     // yield put(requestRolePermissionFail(error));
//   }

//   //====================================================================================================================

// }

// export function* setRolePermission({ payload }) {

//   console.log('[sages] setRolePermission : ', payload);

//   //====================================================================================================================

//   try {

//     async function saveRolePermission() {
//       await sessionStorage.setItem(PERMISSIONS_INFO_KEY, JSON.stringify(payload));
//     }

//     saveRolePermission();


//     console.log("[sages] setRolePermission Success : ");

//     yield put(requestRolePermissionSuccess(payload));

//   } catch (error) {

//     console.log("[sages] setRolePermission Fail : ", error);
//     yield put(requestRolePermissionFail(error));
//   }

//   //====================================================================================================================

// }


export function* watchAuthen() {

  /*console.log('[sages] watchAuthen : ✅');*/

  yield all([
    takeLatest(requestLogoutStart, requestLogout),
    takeLatest(authenStart, requestLogin),
    takeLatest(requestPingStart, requestPing),
    // takeLatest(requestRolePermissionStart, requestRolePermission),
    // takeLatest(setRolePermissionStart, setRolePermission),
  ])
}



